import { useContext } from 'react';
import { Box, Paper, Grid } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { getDateLocale } from '../../../lib/dateLocale';
import {
    AppContext,
    SttLabelForm,
    SttFormTextarea,
    SttFormSelect,
} from '../../../sporttia/all';

/**
 * FIRST STAGE: user
 */
export default function BookingSectionMainData({
    sc,
    piece,
    column,
    notes,
    timeini,
    timeend,
    onChangeTimeini,
    onChangeTimeend,
    onChangeNotes,
}: any) {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();

    return (
        <Box mt={3}>
            <Paper>
                <Box p={3}>
                    <Grid container spacing={3} justifyContent="center">
                        <SttLabelForm
                            grid
                            md={5}
                            title={t('labels.date')}
                            text={format(
                                parseISO(piece.ini),
                                'EEEE, d MMMM yyyy',
                                { locale: getDateLocale() },
                            )}
                        />

                        <SttLabelForm
                            grid
                            md={7}
                            title={t('facility.facility')}
                            text={[sc.short || sc.name, column.facility.name]
                                .filter(Boolean)
                                .join(', ')}
                        />

                        {cxt.user?.role === cxt.constants.roleSC && (
                            <SttFormTextarea
                                grid
                                md={12}
                                sm={12}
                                xs={12}
                                caption={t('labels.notes')}
                                defVal={notes}
                                onChange={({ value }: any) =>
                                    onChangeNotes(value)
                                }
                            />
                        )}

                        {column && (
                            <>
                                <SttFormSelect
                                    grid
                                    md={4}
                                    xs={6}
                                    sm={6}
                                    defVal={timeini}
                                    onChange={({ value }: any) =>
                                        onChangeTimeini(value)
                                    }
                                    options={column.pieces.map((p: any) => ({
                                        caption: format(
                                            parseISO(p.ini),
                                            'H:mm',
                                        ),
                                        value: p.ini,
                                    }))}
                                />

                                <SttFormSelect
                                    grid
                                    md={4}
                                    xs={6}
                                    sm={6}
                                    defVal={timeend}
                                    onChange={({ value }: any) =>
                                        onChangeTimeend(value)
                                    }
                                    options={column.pieces.map((p: any) => ({
                                        caption: format(
                                            parseISO(p.end),
                                            'H:mm',
                                        ),
                                        value: p.end,
                                    }))}
                                />
                            </>
                        )}
                    </Grid>
                </Box>
            </Paper>
        </Box>
    );
}
